const config = {
  API_BASE_URL: '/prod-api'
}

export default config
